// (c) Copyright 2024-2025 Hewlett Packard Enterprise Development LP
import { useLocation } from "react-router-dom"
import { usePrefixedNavigate } from "../hooks/use-prefixed-navigate"
import { Button, Heading } from "grommet"
import { getTestIdAttribute, header } from "../utils/test-ids"

export default function BrandButton({ children }) {
  const location = useLocation()
  const navigate = usePrefixedNavigate()

  const isLaunchpad = location.pathname === "/"

  return (
    <Button
      href="/"
      style={isLaunchpad ? { cursor: "default" } : {}}
      label={
        <Heading weight={600} size="16px">
          {children}
        </Heading>
      }
      onClick={(event) => {
        event.preventDefault()
        if (!isLaunchpad) navigate("/")
      }}
      plain
      {...getTestIdAttribute(header.brand)}
    />
  )
}
